import React, { useEffect } from "react";
import DateTimeRangePicker from "@/shared/components/ui/date-time-range-picker/date-time-range-picker.tsx";
import { useDateTimeRangeStore } from "@/shared/stores/useDateTimeRangeStore.ts";

interface DateTimeRangeModalProps {
  payload: Record<string, never>; // Empty payload
  onClose: () => void;
}

const DateTimeRangeModal: React.FC<DateTimeRangeModalProps> = ({ onClose }) => {
  const { value } = useDateTimeRangeStore();
  const initialValueRef = React.useRef(value);

  // Auto-close modal when Save is clicked (value changes)
  useEffect(() => {
    // Skip the initial render
    if (value === initialValueRef.current) return;

    // Value changed - user clicked Save - close the modal
    const timer = setTimeout(() => {
      onClose();
    }, 100);

    return () => clearTimeout(timer);
  }, [value, onClose]);

  return (
    <div className="flex flex-col w-full">
      <DateTimeRangePicker />
    </div>
  );
};

export default DateTimeRangeModal;
